import { axiosNT, axiosNTL } from '../../../services/axios';
import { ClientListItem } from "../types/ClientListItem";
import { Client } from "../types/Client";
import { SearchData } from "../types/SearchData";
import axios from '../../../services/axios';
import ACLService from '../../acl/services/aclService';

const getClients = (payload: any) => {
    let { pageNumber, searchQuery } = payload;
    if(pageNumber === undefined) { pageNumber = 1 }
    return axiosNT.get('/client/v4/list', {params: {pageNumber: pageNumber, searchQuery: searchQuery}})
    .then((res: any) => {
        // let clients: ClientListItem[] = res.responseObject;
        return Promise.resolve(res.responseObject);
    })
}

const getMasterClients = () => {
    return axiosNT.get('/client/v4/master-client')
    .then((res: any) => {
        return Promise.resolve(res.responseObject);
    })
}

const getClientsWithoutPagination = (pagination: boolean = false) => {
    return axiosNT.get('/client/v4/list', {params: {pagination: pagination}})
    .then((res: any) => {
        return Promise.resolve(res.responseObject);
    })
}
const getRolesListWithoutPagination = (clientId: any, pagination: boolean = false) => {
    return axiosNT.get('/role/v4/get', {params: {pagination: pagination, clientId: clientId}})
    .then((res: any) => {
        return Promise.resolve(res.responseObject);
    })
}

const getRolesList = (payload: any) => {
    let { pageNumber, rolesSearch } = payload;
    let getDefaultRoles = ACLService.isSuperAdmin() ? false : true;
    const checkedRoleNames = rolesSearch && rolesSearch.roleNames
                                .split(',')
                                    .filter((roleName: string) => roleName !== '')
                                        .join(',')
    const checkedClientNames = rolesSearch && rolesSearch.clientNames
                                .split(',')
                                    .filter((clientName: string) => clientName !== '')
                                        .join(',')

    return axiosNT.get('/role/v4/get', {params: {
        pageNumber: pageNumber, 
        getDefaultRoles: getDefaultRoles,
        roleNames: (rolesSearch && checkedRoleNames) || '',
        clientNames: (rolesSearch && checkedClientNames) || ''
    }})
    .then((res: any) => {
        let rolesData: any[] = res.responseObject;
        return Promise.resolve(rolesData);
    })
}
const getDefaultRolesList = (pageNumber: number = 1) => {
    return axiosNT.get('/role/v4/default')
    .then((res: any) => {
        let rolesData: any[] = res.responseObject;
        return Promise.resolve(rolesData);
    })
}
const getClient = (id: string) => {
    return axiosNT.get('/client/v4/list', {params: { clientId: id}})
    .then((res: any) => {
        let client: Client = res.responseObject;
        return Promise.resolve(client);
    })
}

const getRoleById = (id: string) => {
    return axiosNT.get('/role/v4/get', {params: { roleId: id}})
    .then((res: any) => {
        let client: Client = res.responseObject ? res.responseObject : res;
        return Promise.resolve(client);
    })
    .catch((error: any) =>  {
        return Promise.resolve(error.response)
    })
}

const editRole = (role: any) => {
    return axiosNT.put(`/role/v4/update/${role.roleId}`, role.data, { headers: { 'Content-Type' : 'application/json'}})
    .then((res: any) => {
        return Promise.resolve(res)
    })
    .catch((error: any) =>  {
        return Promise.resolve(error.response)
    })
}

const addClient = (client: any) => {
    return axiosNT.post('/client/v4/create', client, {headers: { 'Content-Type': 'application/json'}})
    .then((res: any) => {
        return Promise.resolve(res);
    })
    .catch((error: any) =>  {
        console.log(error);
    })
}

const addRole = (role: any) => {
    return axiosNT.post('/role/v4/create', role, {headers: { 'Content-Type': 'application/json'}})
    .then((res: any) => {
        return Promise.resolve(res);
    })
    .catch((error: any) =>  {
        return Promise.resolve(error.response)
    })
}

const addUser = (user: any) => {
    return axios.post('/user/create', user, {headers: { 'Content-Type': 'application/json'}})
    .then((res: any) => {
        return Promise.resolve(res);
    })
    .catch((error: any) =>  {
        return Promise.resolve(error.response)
    })
}

const setBulkImportTest = (payload: any) => {
    return axiosNT.post('/course-plan/bulk-test', payload, {headers: { 'Content-Type': 'application/json'}})
    .then((res: any) => {
        return Promise.resolve(res);
    })
    .catch((error: any) =>  {
        return Promise.resolve(error.response)
    })
}


const editClient = (client: any) => {
    return axiosNT.put(`/client/v4/update/${client.clientId}`, client.formData, { headers: { 'Content-Type' : 'application/json'}})
    .then((res: any) => {
        return Promise.resolve(res);
    })
}

const editUser = (data: any) => {
    return axiosNT.patch('/user/updateUserById', data, { headers: { 'Content-Type' : 'application/json'}})
    .then((res: any) => {
        return Promise.resolve(res);
    })
}

const deleteClient = (clientData: any) => {
    return axios.delete('', clientData)
    .then((res: any) => {
        let response = res.responseObject;
        return Promise.resolve(response);
    })
}

const clientCount = () => {
    return axiosNTL.get('')
    .then((res: any) => {
        let response = res.responseObject && res.responseObject > 0 ? res.responseObject : 0;
        return Promise.resolve(response);
    })
}

const nextPage = (pageNumber: any) => {
    return axiosNTL.get('', { params: { pageNumber: pageNumber}}) 
        .then((res: any) => {

        })
}

const prevPage = () => {

}

const getUsers = (payload: any) => {
    let {pageNumber, usersSearch} = payload;
    if(pageNumber === undefined) { pageNumber = 1 }
    const checkedUserDetails = usersSearch && usersSearch.userDetails
                                    .split(',')
                                        .filter((userDetail:string) => userDetail !== '')
                                            .join(',')
    const checkedClientNames = usersSearch && usersSearch.clientNames
                                    .split(',')
                                        .filter((clientName: string) => clientName !== '')
                                            .join(',')
    const checkedRoleNames = usersSearch && usersSearch.roleNames
                                    .split(',')
                                        .filter((roleName:string) => roleName !== '')                                        
                                            .join(',')
    return axiosNT.get('/user', {params: {
        pageNumber: pageNumber,
        userDetails:(usersSearch && checkedUserDetails) || '',
        isActive: (usersSearch && usersSearch.status),
        clientNames: (usersSearch && checkedClientNames) || '',
        roleNames: (usersSearch && checkedRoleNames) || ''

    }})
    .then((res: any) => {
        return Promise.resolve(res.responseObject);
    })
}

const getUsersByEmail = (email: string) => {
    return axiosNT.get('/user', {params: {
        userDetails: email

    }})
    .then((res: any) => {
        return Promise.resolve(res.responseObject);
    })
}

const getUserById = (id: string) => {
    return axiosNT.get(`/user/userDetail/${id}`)
    .then((res: any) => {
        let client: Client = res.responseObject;
        return Promise.resolve(client);
    })
}

const getSubjectList = (pageNumber: number = 1) => {
    return axiosNT.get('/subject')
    .then((res: any) => {
        return Promise.resolve(res.responseObject);
    })
}

const getCourseList = (params:any) => {
    let api='/package/v4';
    let paramsTxt="";
    if(params){
        const keys=Object.keys(params);
        if(keys){
           paramsTxt= keys.reduce((acc,key,index)=>{  
             if(Array.isArray(params[key])){
                 let commaSeparatedValues=params[key].join(',');
                 acc=acc+key+'='+commaSeparatedValues+'&';
             }else{  
               acc=acc+key+'='+params[key]+'&';
             }
             return acc; 
            },'?');
         }
       }
    // pageNumber: number = 1
    return axiosNT.get(api+paramsTxt)
    .then((res: any) => {
        return Promise.resolve(res.responseObject.packages);
    })
}

const searchClients = (searchData: any) => {    
    return axiosNT.get(`/client/v4/list?searchQuery=${searchData.searchQuery}`)
    .then((res: any) => {
        return Promise.resolve(res.responseObject);
    })
}

const searchRoles = (searchData: any) => {
    const checkedRoleNames = searchData.roleNames.split(',')
                                .filter((roleName: string) => roleName !== '' )
                                .join(',');
    const checkedClientNames = searchData.clientNames.split(',')
                                .filter((clientName: string) => clientName !== '')
                                .join(',');

    return axiosNT.get(`/role/v4/get?roleNames=${checkedRoleNames}&clientNames=${checkedClientNames}`)
        .then((res: any) => {
            return Promise.resolve(res.responseObject);
        })
}

const searchUsers = (searchData: any) => {
    const checkedRoleNames = searchData.roleNames.split(',')
                                .filter((roleName: string) => roleName !== '')
                                .join(',')
    const checkedClientNames = searchData.clientNames.split(',')
                                .filter((clientName: string) => clientName !== '')
                                .join(',')
    const checkedUserDetails = searchData.userDetails.split(',')
                                .filter((userDetail:string) => userDetail !== '')
                                .join(',')
    return axiosNT.get(`/user?isActive=${searchData.isActive}&userDetails=${checkedUserDetails}&clientNames=${checkedClientNames}&roleNames=${checkedRoleNames}`)
        .then((res: any) => {
            return Promise.resolve(res.responseObject);
        })
}

const clientServices = {
    getClients,
    getMasterClients,
    getClient,
    addClient,   
    editClient,
    deleteClient,
    clientCount,
    nextPage,
    prevPage,
    getRolesList,
    getClientsWithoutPagination,
    getRolesListWithoutPagination,
    addRole,
    getRoleById,
    editRole,
    getUsers,
    getSubjectList,
    getCourseList,
    addUser,
    getUserById,
    editUser,
    searchClients,
    searchRoles,
    searchUsers,
    getDefaultRolesList,
    getUsersByEmail,
    setBulkImportTest
}

export default clientServices;